import React from "react";
import { useSelector } from "react-redux";
import { isDateExpired, isDateBeforeMin } from "../../../utils/dateUtils";
import DateTimeField from "../dateTimeField/DateTimeField";
import classes from "./ScheduleFields.module.css";


const ScheduleFields = ({ fromDate, toDate, onFromDateChange, onToDateChange, fromLabel, toLabel, minFromDate }) => {

    const { texts } = useSelector((state) => state.translate);
    const hasRangeError = fromDate && toDate && new Date(fromDate) >= new Date(toDate);
    const hasExpiredToDate = isDateExpired(toDate);
    const hasPastFromDate = isDateBeforeMin(fromDate, minFromDate);
    const hasMissingFrom = !fromDate;
    const hasMissingTo = !toDate;
    const hasEndDateError = hasMissingTo || hasRangeError || hasExpiredToDate;

    return (
        <div className={classes.Wrap}>
            {hasRangeError && <p className={classes.ErrorText}>{texts.messageInvalidDateRange}</p>}
            {hasExpiredToDate && <p className={classes.ErrorText}>{texts.messageEndDateExpired}</p>}

            <div className={classes.Row}>
                <DateTimeField
                    inputId="message-publish-date"
                    label={labelWithStar(fromLabel ?? texts.messagePublishDate, hasMissingFrom || hasRangeError || hasPastFromDate)}
                    value={fromDate}
                    onChange={onFromDateChange}
                    min={minFromDate}
                />
                <DateTimeField
                    inputId="message-end-date"
                    label={labelWithStar(toLabel ?? texts.messageEndDate, hasEndDateError)}
                    value={toDate}
                    onChange={onToDateChange}
                />
            </div>
        </div>
    );
};

export default ScheduleFields;

const labelWithStar = (text, hasError) => (
    <>
        {text}
        {hasError && <span className={classes.RequiredStar}> *</span>}
    </>
);
export const hasScheduleFieldsError = (fromDate, toDate, minFromDate) => !fromDate || !toDate || new Date(fromDate) >= new Date(toDate) || isDateExpired(toDate) || isDateBeforeMin(fromDate, minFromDate);
